module.exports = __webpack_public_path__ + "img/agriculture.9738595f.svg";